import React, { useEffect, useState } from "react";
import API from '../Services/ProductType'
import APIS from '../Services/SalesTab'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import APISS from '../Services/Location'
import ProductTypeList from "../Components/ProductTypeList";

const ProductType = () => {
  const [weekdays, setWeekdays] = useState({
    Sunday: false,
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: false,
  });

  const [name, setName] = useState("")
  const [salesTab, setSalesTab] = useState([])
  const [buttonColor, setButtonColor] = useState("")
  const [displayOrder, setDisplayOrder] = useState([])
  const [location, setLocation] = useState([])
  const [trackInventory, setTrackInventory] = useState("")
  const [isCombo, setISCombo] = useState("")
  const [isShowtoCustomer, setIsShowtoCustomer] = useState("")

  const [selectSalesTab, setSelectSalesTab] = useState("")
  const [error, setError] = useState({});

  const [selectedLocation, setSelectedLocation] = useState([])
  const [isRecipe, setIsRecipe] = useState("")
  const [waiverRequired, setWaiverRequired] = useState("")
  const [selected, setSelected] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [getSelectAll, setGetSelectAll] = useState(false);


  const [salesTabSelected, setSalesTabSelected] = useState([]);
  const [selectAllSalesTab, setSelectAllSalesTab] = useState(false);
  const [getSelectAllSalesTab, setGetSelectAllSalesTab] = useState(false);

  const [showSalesTapModal, setSalesTapModal] = useState(false);
  const [enableParty, setEnableParty] = useState("")
  const [allDaysChecked, setAllDaysChecked] = useState(false);

  const validateFields = () => {
    const errors = {};
    if (!name.trim()) errors.name = "Name is required";
    if (!displayOrder) {
      errors.displayOrder = "Display order is required";
    }
    setError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFieldChange = (e, fieldName) => {
    const value = e.target.value;
    if (value.trim()) {
      setError((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[fieldName];
        return updatedErrors;
      });
    }

    switch (fieldName) {
      case "name":
        setName(value);
        break;
      case "selectSalesTab":
        setSelectSalesTab(value);
        break;
      case "selectedLocation":
        setSelectedLocation(value);
        break;
      case "displayOrder":
        setDisplayOrder(value);
        break;
      case "isRecipe":
        setIsRecipe(value);
        break;
      default:
        break;
    }
  };

  const handleError = (error) => {
    if (error.response) {
      toast.error(error.response.data?.message || `Error: ${error.response.status}`);
    } else if (error.request) {
      toast.error("No response from server. Please try again later.");
    } else {
      toast.error("Something went wrong. Please try again.");
    }
  };


  const getSalesTab = async (location) => {
    location = location;
    try {
      const location_ids = Array.isArray(location) ? location.join(",") : location;
      const isMultiple = Array.isArray(location) && location.length > 1 ? 1 : 0;
      const response = await APIS.Sales_Tab_List({
        is_active: 1,
        limit: 0,
        pageNumber: 1,
        location_ids,
        is_multiple: isMultiple
        // is_multiple: 1
      });
      //console.log('responseresponse', response?.data?.data);
      setSalesTab(response?.data?.data || []);
      // setSalesTapModal(true);
    } catch (error) {
      setError((prev) => ({ ...prev, salesTab: "Failed to fetch sales tab data." }));
      handleError(error);
      if (error.response?.status === 403) {
        window.location.replace("/Login");
      }
    }
  };


  const allWeekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

  // const handleWeekdayChange1 = (day) => {
  //   setWeekdays((prevWeekdays) => ({
  //     ...prevWeekdays,
  //     [day]: !prevWeekdays[day],
  //   }));
  // };
  const handleWeekdayChange1 = (day) => {
    const updated = {
      ...weekdays,
      [day]: !weekdays[day],
    };
    setWeekdays(updated);

    // Update "All Days" checkbox status
    const allSelected = allWeekdays.every(d => updated[d]);
    setAllDaysChecked(allSelected);
  };


  const handleAllDaysToggle = () => {
    const newState = !allDaysChecked;
    const updatedWeekdays = {};
    allWeekdays.forEach(day => {
      updatedWeekdays[day] = newState;
    });
    setWeekdays(updatedWeekdays);
    setAllDaysChecked(newState);
  };


  useEffect(() => {
    bindLocation()
  }, [])

  const bindLocation = async () => {
    try {
      const response = await APISS.getLocationList({
        is_active: 1,
        limit: 0,
      });
      setLocation(response?.data?.data || []);
    } catch (error) {
      if (error.response.status == 403) {
        window.location.replace("/Login");
      }
      setError("Failed to fetch locations.");
      console.error(error);
    }
  };


  const handleCheckboxChange = (id) => {
    const updated = [...selected];
    const locationIndex = location.findIndex((loc) => loc.id === id);
    updated[locationIndex] = !updated[locationIndex];
    setSelected(updated);

    setSelectAll(updated.filter(Boolean).length === location.length);
    const selectedLocationIds = location
      .map((loc, index) => (updated[index] ? loc.id : null))
      .filter((id) => id !== null);
   // console.log("Selected Location IDs:", selectedLocationIds);
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);

    const updatedSelected = new Array(location.length).fill(checked);
    setSelected(updatedSelected);
    if (checked) {
      const allLocationIds = location.map((loc) => loc.id);
      //console.log("All Selected Location IDs:", allLocationIds);
    } else {
      console.log("No locations selected");
    }
  };
  const handleOk = () => {
    const selectedLocationIds = location
      .map((loc, index) => (selected[index] ? loc.id : null))
      .filter((id) => id !== null);
    setGetSelectAll(selectedLocationIds);
    //   console.log('selectedLocationIds', selectedLocationIds);
    getSalesTab(selectedLocationIds);

  };


  const handleCancelEdit = () => {
    setName('')
    // setLocation('')
    setButtonColor('')
    setDisplayOrder('')
    setISCombo('')
    setWeekdays('')
    setTrackInventory('')
    setWaiverRequired('')
    setSelectSalesTab('')
    // setEnableParty('')

  };

  const handleSubmit = async () => {
    if (!validateFields()) return;
    await addProductType();
  };
  const addProductType = async () => {
   // console.log('selectSalesTab', selectSalesTab);
    if (!validateFields()) return;

    if (!selectedLocation) {
      toast.error("Please select a location.");
      return;
    }
    if (!selectSalesTab) {
      toast.error("Please select a sales tab.");
      return;
    }

    const selectedDays = Object.keys(weekdays).filter(day => weekdays[day]);

    if (!Array.isArray(selectedDays) || selectedDays.length === 0) {
      toast.error("Please select at least one weekday.");
      return;
    }

    const weekList =
      selectedDays.length === allWeekdays.length
        ? "All Days"
        : selectedDays.join(", ");

    let updatedTrackInventory = trackInventory !== "" ? trackInventory : false;
    let updatedIsCombo = isCombo !== "" ? isCombo : false;
    let updatedIsShowCustomer = isShowtoCustomer !== "" ? isShowtoCustomer : false;
    let updatedIsRecipe = isRecipe !== "" ? isRecipe : false;
    let updateWaiverRequred = waiverRequired !== "" ? waiverRequired : false;

    const isMultiple = selectSalesTab.length > 1 ? 1 : 0;
  //  console.log('isMultiple', isMultiple);
    // let updateEnableParty = enableParty !== "" ? enableParty : false;

    const payload = {
      name: name,
      sale_tab_id: selectSalesTab,
      display_order: parseInt(0),
      //location_id: parseInt(0),
      track_inventory: updatedTrackInventory,
      // track_inventory: false,
      is_combo: updatedIsCombo,
      week_list: weekList,
      is_recipe: updatedIsRecipe,
      is_active: true,
      show_to_customer: updatedIsShowCustomer,
      is_waiver_required: updateWaiverRequred,
      // is_party: updateEnableParty,
      is_multiple: isMultiple

    };
    // console.log("Payload data:", payload);
    
    try {
      const response = await API.addProductTYpe(payload);
      if (response.status === 200) {
        toast.success(response?.data?.message || "Product type added successfully!");
        setTimeout(() => window.location.reload(), 2000);
      } else {
        toast.error("Unexpected response:", response);
      }

    } catch (error) {
      handleError(error);
    //  console.error("Error adding product type:", error);
    }
  };

  const handelReset = () => {
    setSelected("");
  }

  const handleChange = (e) => {
    const value = e.target.value;
    //console.log('aaaa',value);
    setSelectSalesTab(value);
    setError((prevErrors) => {
      const updatedErrors = { ...(prevErrors || {}) };
      delete updatedErrors.salesTab;
      return updatedErrors;
    });
  };
  return (
    <div >
      <div className="col-12 grid-margin stretch-card">
        <div className="card">

          <div className="card-body">
            <h4 className="card-title">Product Type </h4>
            <form>
              {/* Row 1 */}
              <div className="row mb-1">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="txtname" className="form-label">
                      Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="txtname"
                      placeholder="Name"
                      value={name}
                      onChange={(e) => handleFieldChange(e, "name")}
                    />
                    {error.name && <small className="text-danger">{error.name}</small>}
                  </div>
                </div>
                <div className="col-md-4">
                  <lable>Center <span style={{ color: "red" }}>*</span></lable>

                  <div className="dropdown">
                    <button
                      className="btn dropdown-toggle form-control text-start"
                      type="button"
                      aria-expanded="false"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModalCenter"
                    >
                      {(() => {
                        const selectedLocations = location
                          .filter((_, index) => selected[index])
                          .map((loc) => loc.name);

                        if (selectedLocations.length === 0) return "Select Centers";

                        const combined = selectedLocations.join(", ");

                        return combined.length > 20 ? `${combined.slice(0, 20)}...` : combined;
                      })()}
                    </button>
                    {error.locationId && <small className="text-danger">{error.locationId}</small>}
                  </div>

                </div>
                <div className="col-md-4">
                  <label>Sales Tab <span style={{ color: "red" }}>*</span></label>

                  <select
                    className="form-select"
                    id="ddSalesType"
                    value={selectSalesTab}
                    onChange={handleChange}
                  >
                    <option value="">Select Sales Tab</option>
                    {salesTab.map((tab, index) => (
                      <option key={index} value={tab.id}>
                        {tab.tab_name}
                      </option>
                    ))}
                  </select>

                </div>

              </div>
              <div className="row mb-3">

                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="isCombo" className="form-label">
                      Is Combo
                    </label>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input ms-1"
                        id="isCombo"
                        checked={isCombo} onChange={() => setISCombo(!isCombo)}
                      />
                      <label htmlFor="isCombo" className="form-check-label">
                        Enable Combo
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="isShowtoCustomer" className="form-label">
                      {/* Show To Customer */}
                    </label>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input ms-1"
                        id="isshowtocustomer"
                        checked={isShowtoCustomer} onChange={() => setIsShowtoCustomer(!isShowtoCustomer)}
                      />
                      <label htmlFor="isShowtoCustomer" className="form-check-label">
                        Show to Customer
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="isShowtoCustomer" className="form-label">
                      {/* Show To Customer */}
                    </label>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input ms-1"
                        id="ticketInventory"
                        checked={trackInventory} onChange={() => setTrackInventory(!trackInventory)}
                      />
                      <label
                        htmlFor="ticketInventory"
                        className="form-check-label"
                      >
                        Enable Inventory
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="isWaiver" className="form-label">
                      {/* Waiver Required */}
                    </label>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input ms-1"
                        id="isWaiver"
                        checked={waiverRequired} onChange={() => setWaiverRequired(!waiverRequired)}
                      />
                      <label htmlFor="isWaiver" className="form-check-label">
                        Waiver Required
                      </label>
                    </div>
                  </div>
                </div>

                {/* <div className="row"> */}
                {/* <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="isParty" className="form-label">
                   
                    </label>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input ms-1"
                        id="isParty"
                        checked={enableParty} onChange={() => setEnableParty(!enableParty)}
                      />
                      <label htmlFor="isParty" className="form-check-label">
                        Enable Party Booking
                      </label>
                    </div>
                  </div>
                </div> */}
                {/* </div> */}
              </div>
              <div className="row mb-4">
                <div className="col-md-12">
                  <div className="form-group">
                    <label className="form-label">Weekday List (All Days)
                      <input
                        type="checkbox"
                        checked={allDaysChecked}
                        onChange={handleAllDaysToggle}
                        className="form-check-input me-3" /></label>
                    <div className="d-flex flex-wrap">
                      {allWeekdays.map((day) => (
                        <div className="form-check me-3" key={day}>
                          <input
                            type="checkbox"
                            className="form-check-input ms-1"
                            id={day}
                            checked={weekdays[day] || false}
                            onChange={() => handleWeekdayChange1(day)}
                          />
                          <label htmlFor={day} className="form-check-label">{day}</label>
                        </div>
                      ))}
                    </div>

                  </div>
                </div>

              </div>
              <div className="mt-3">
                <button
                  onClick={handleSubmit}
                  type="button"
                  className="btn btn-primary me-3"
                >
                  Submit
                </button>
                <button onClick={handleCancelEdit} className="btn btn-light">Cancel</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <section>
        <div className="modal fade" id="exampleModalCenter" tabIndex="-1" aria-hidden="true">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Select Center</h5>
                <button type="button" className="btn-close" onClick={handelReset} data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="container ms-3 me-2">
                  <div className="form-check mb-3" style={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="select-all"
                      checked={selectAll}
                      onChange={handleSelectAll}
                      style={{ "box-shadow": "0 0 0 1px blue" }}
                    />
                    <label htmlFor="select-all" className="form-check-label"
                      style={{ marginLeft: "8px", cursor: "pointer", userSelect: "none" }}
                    >Select All</label>
                  </div>

                  <div className="row">
                    {location.map((loc, index) => (
                      <div className="col-md-3" key={loc.id}>
                        <div className="form-check" style={{ display: "flex", alignItems: "center" }}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`loc-${index}`}
                            checked={selected[index] || false}
                            onChange={() => handleCheckboxChange(loc.id)}
                            style={{ "box-shadow": "0 0 0 1px blue" }}
                          />
                          <label className="form-check-label" htmlFor={`loc-${index}`}
                            style={{ marginLeft: "8px", cursor: "pointer", userSelect: "none" }}
                          >
                            {loc.name}
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={handelReset}>Close</button>
                <button type="button" className="btn btn-primary" onClick={handleOk} data-bs-dismiss="modal" disabled={selected.length === 0}>OK</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ToastContainer />
      <ProductTypeList />

    </div>
  );
};

export default ProductType;